import { call, put } from 'redux-saga/effects';

import { apiGeneral, queryBuilder, notify } from 'services';
import { IPaginateRequest } from 'interfaces/paginate-duck';
import { requestErrorHandler } from 'utils';
import { PaginateRegionalActions } from 'store/ducks/settings/regional';

export function* paginateRegionalRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/regional?${queryString}`
    );

    const { regional, pagination } = responseBody;
    yield put(PaginateRegionalActions.success(regional, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(PaginateRegionalActions.failure(errorMessage));
  }
}
